<template>
  <div id="app">    
    <!--<MouseCursor />
     <Home msg="Welcome to Your Vue.js App"/> 
    <transition @leave="onLeave">
      <v-if="!preloadComplete"/>
    </transition>    -->
   
    <!--<MouseCursor />-->
    <!-- <lazyComponent /> -->
    <Preload />
    <Main />    
    <Footer />
    <!--<Test />-->
  </div>
</template>

<script>
//import HelloWorld from './components/HelloWorld.vue'
//import MouseCursor from './components/MouseCursor';
import Main from './components/Main';
import Preload from './components/Preload';
import Footer from './components/Footer';
//import Test from './components/Test';



export default {
  name: 'App',
  components: {
    Main,
    //lazyComponent: () => import('./components/Main.vue'),
    //MouseCursor,
    Preload,
    Footer
    //Test
  }  
}
</script>

<style lang="scss">
@import "./styles/global.scss";

#app {
  margin: 0;
    width: 100%;
    
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;  
  /*margin-top: 60px;*/

  display: flex;
  align-items: center;
  justify-content: left;
  /*height: 100vh;*/
}
</style>
